<template>
  <div class="page-container">
    <div class="header">
      <h2>选股</h2>
    </div>
    
    <!-- 二级菜单 -->
    <div class="submenu-container">
      <div class="submenu">
        <button 
          :class="['submenu-item', { active: activeTab === 'single' }]"
          @click="setActiveTab('single')"
        >
          股票股东数
        </button>
        <button 
          :class="['submenu-item', { active: activeTab === 'multiple' }]"
          @click="setActiveTab('multiple')"
        >
          多股票股东数
        </button>
        <button 
          :class="['submenu-item', { active: activeTab === 'industry' }]"
          @click="setActiveTab('industry')"
        >
          行业板块股东数
        </button>
      </div>
    </div>
    
    <!-- 内容区域 -->
    <div class="content-container">
      <!-- 单个股票股东数 -->
      <div v-show="activeTab === 'single'" class="tab-content">
        <SingleStockHolder />
      </div>
      
      <!-- 多个股票股东数 -->
      <div v-show="activeTab === 'multiple'" class="tab-content">
        <MultipleStockScore />
      </div>
      
      <!-- 行业板块股东数 -->
      <div v-show="activeTab === 'industry'" class="tab-content">
        <IndustryPlateHolders />
      </div>
    </div>
  </div>
</template>

<script>
import SingleStockHolder from './SingleStockHolder.vue';
import MultipleStockScore from './MultipleStockScore.vue';
import IndustryPlateHolders from './IndustryPlateHolders.vue';

export default {
  name: 'Choose',
  components: {
    SingleStockHolder,
    MultipleStockScore,
    IndustryPlateHolders
  },
  data() {
    return {
      activeTab: 'single' // 默认激活第一个标签
    };
  },
  methods: {
    setActiveTab(tab) {
      this.activeTab = tab;
    }
  }
};
</script>

<style scoped>
.page-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.header {
  margin-bottom: 30px;
}

.header h2 {
  color: #2c3e50;
  font-size: 2rem;
  margin: 0;
}

/* 二级菜单样式 */
.submenu-container {
  margin-bottom: 30px;
}

.submenu {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.submenu-item {
  padding: 12px 24px;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  color: #666;
  transition: all 0.3s ease;
}

.submenu-item:hover {
  background-color: #e9ecef;
  color: #2c3e50;
}

.submenu-item.active {
  background-color: #42b983;
  color: white;
  border-color: #42b983;
  box-shadow: 0 2px 8px rgba(66, 185, 131, 0.3);
}

/* 内容区域样式 */
.content-container {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  min-height: 400px;
}

.tab-content {
  min-height: 300px;
}
</style>